import { ReleaseDetail } from "./release-detail";

// WIRE CONTRACT — the numeric value is persisted and crosses the wire to platform-portal-api and
// the downstream ReleaseReport function. These ordinals MUST stay byte-identical with those two
// (PlatformPortalApi Models/ReleaseReport/ReviewClassification.cs and
// DevOpsReleaseReportAzureFx.Data.Entities.ReviewClassification). Treat as APPEND-ONLY: never
// reorder or insert in the middle — it would silently remap persisted rows and in-flight edits.
export enum ReviewClassification {
  NeedsReview = 0,
  Reviewed = 1,
  AzureIssue = 2,
  ADOIssue = 3,
  CloudflareIssue = 4,
  TestsIssue = 5,
  OtherIssue = 6
}

export interface Release {
  id: number,
  pipelineName: string,
  releaseStartedDate: Date,
  releaseStartedDateLocal: Date,
  branchName: string,
  releaseStatus: boolean,
  reviewed: boolean,
  adoReleaseId: string,
  releaseName: string,
  team: string,
  releaseLink: string,
  description: ReleaseDetail[],
  changeFail: boolean,
  isYaml: boolean,
  isTransient: boolean,
  reviewClassification?: ReviewClassification,
  releaseEnvironments?: AdoReleaseEnvironment[]
}

export interface AdoReleaseEnvironment {
  Id: number;
  Name: string;
  Status: string;
  StartedDateTimeUtc: string;
  FinishedDateTimeUtc: string;
  SucceededDateTimeUtc: string;
  RejectedDateTimeUtc: string;
  ReleaseId: number;
  Attempts: number;
}

export interface ReleaseReportRelease {
  ReleaseId: number;
  ProjectId: string;
  RepositoryId: string;
  PipelineName: string;
  BranchName: string;
  ReleaseName: string;
  StartedDateTimeUtc: string;
  FinishedDateTimeUtc: string;
  Success: boolean;
  Reviewed: boolean | null;
  ChangeFail: boolean | null;
  IsYaml: boolean;
  ReleaseStartedBy: string;
  AdoReleaseId: string;
  SourceVersion: string;
  ArtifactType: string | null;
  ReleaseEnvironments: AdoReleaseEnvironment[];
  ReleaseDetails: ReleaseDetail[];
}

export interface ReleaseReportReleasesResponse {
  Release: ReleaseReportRelease;
  Details: ReleaseDetail[];
}

